/* router.svelte.js generated by Svelte v5.56.9 */
import * as $ from 'svelte/internal/client';
import { matchRoute, normalizePath } from "./routes.js";

export const route = $.tag_proxy(
	$.proxy({
		name: "home",
		params: {},
		path: "/",
		query: new URLSearchParams()
	}),
	'route'
);

function apply(url) {
	const match = matchRoute(url.pathname);

	route.name = match.name;
	route.params = match.params;
	route.path = match.path;
	route.query = new URLSearchParams(url.search);
}

export function startRouter() {
	apply(new URL(window.location.href));
	window.addEventListener("popstate", () => apply(new URL(window.location.href)));

	// One delegated listener beats an onclick on every link in the app.
	document.addEventListener("click", (event) => {
		if (event.defaultPrevented || $.strict_equals(event.button, 0, false) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
			return;
		}

		const anchor = event.target instanceof Element ? event.target.closest("a") : null;

		if (!anchor) return;

		const href = anchor.getAttribute("href");

		if (!href || href.startsWith("http") || href.startsWith("mailto:") || $.strict_equals(anchor.target, "_blank")) return;
		if (anchor.hasAttribute("download") || $.strict_equals(anchor.dataset.native, undefined, false)) return;

		event.preventDefault();
		navigate(href);
	});
}

export function navigate(href, { replace = false, scroll = true } = {}) {
	const url = new URL(href, window.location.origin);

	if ($.strict_equals(url.href, window.location.href)) return;
	if (replace) window.history.replaceState({}, "", url); else window.history.pushState({}, "", url);

	apply(url);

	if (scroll) window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
}

/** Updates the query string without adding a history entry (used by filters). */
export function replaceQuery(patch) {
	const url = new URL(window.location.href);

	for (const [key, value] of Object.entries(patch)) {
		// Delete first, so an array replaces the whole set instead of appending to the old one.
		url.searchParams.delete(key);

		if (Array.isArray(value)) {
			for (const item of value) {
				if ($.strict_equals(item, undefined, false) && $.strict_equals(item, null, false) && $.strict_equals(item, "", false)) url.searchParams.append(key, String(item));
			}
		} else if ($.strict_equals(value, undefined, false) && $.strict_equals(value, null, false) && $.strict_equals(value, "", false)) {
			url.searchParams.set(key, String(value));
		}
	}

	window.history.replaceState({}, "", url);
	apply(url);
}

export function currentPath() {
	return normalizePath(window.location.pathname);
}